/**
 * ActorDescriptorPage - Actor descriptor management
 *
 * Surfaces the ActorDescriptorManager from @ferp/workflow-forms for admin/architect users.
 * Provides management of actor descriptors, capabilities, and metadata.
 *
 * Route: /admin/actor-descriptors
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconUserCog } from '@tabler/icons-react';

import { ActorDescriptorManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ActorDescriptorPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconUserCog size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Actor Descriptors</Title>
            <Text size="sm" c="dimmed">
              Manage actor definitions, capabilities, and metadata configurations
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ActorDescriptorManager />
    </Container>
  );
}

export default ActorDescriptorPage;
